export const CONFIG = window.bigcommerce_config || {};
export const CART = CONFIG.cart || {};
export const IMAGES_URL = CONFIG.images_url || {};
export const TEMPLATE_URL = CONFIG.template_url || {};
export const CART_API_BASE = CONFIG.cart.api_url || '';
export const AJAX_CART_ENABLED = CONFIG.cart.ajax_enabled || '';
export const AJAX_CART_NONCE = CONFIG.cart.ajax_cart_nonce || '';
export const COUNTRIES_OBJ = CONFIG.countries || {};
export const PRODUCT_MESSAGES = CONFIG.product.messages || '';
export const PRICING_API_URL = CONFIG.pricing.api_url || '';
export const PRODUCTS_API_URL = CONFIG.product.api_url || '';
export const PRICING_API_NONCE = CONFIG.pricing.ajax_pricing_nonce || '';
export const PRODUCTS_API_NONCE = CONFIG.product.ajax_products_nonce || '';
export const MINI_CART = CONFIG.cart.mini_cart.enabled || false;
export const STORE_DOMAIN = CONFIG.store_domain || '';
export const SHIPPING_API_ZONES = CONFIG.cart.zones_api_url || '';
export const SHIPPING_API_METHODS = CONFIG.cart.methods_api_url || '';
export const CURRENCY_CODE = CONFIG.currency_code || '';
export const COUPON_CODE_ADD = CONFIG.cart.coupon_code_add_api_url || '';
export const COUPON_CODE_REMOVE = CONFIG.cart.coupon_code_delete_api_url || '';
export const BANNERS = CONFIG.banners || [];
